import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import { StyledContactForm, FeatureTextWrapper, FeatureTitle } from './ContactStyles';

export const ContactUs = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    
      emailjs.sendForm('service_mq25opd', 'template_7zy7aja', form.current, '2B-uZAbLC0f1CqOna')
      .then((result) => {
          console.log("message sent");
      }, (error) => {
          console.log(error.text);
      });
      alert("Ihre Nachricht wurde erfolgreich verschickt.")
    }

  return (
    <>
    <div className="header" style={{padding:"60px 0", display:"flex", flexDirection:"column", justifyContent:"center", background:"#940000"}}></div>
    
    <FeatureTextWrapper>
			<FeatureTitle>Nehmen Sie Kontakt mit uns auf!</FeatureTitle>
		</FeatureTextWrapper>
    <StyledContactForm>
        <form ref={form} onSubmit={sendEmail}>
          <label>Name</label>
          <input type="text" name="user_name" />
          <label>Email</label>
          <input type="email" name="user_email" />
          <label>Message</label>
          <textarea name="message" />
          <input type="submit" value="Send" />
        </form>
    </StyledContactForm>
   
    </>
    
    
  );
};

export default ContactUs;